<template>
  <modal title="Update Password" width="45" :showModal="showModal" @close-modal="closeModal">
    <p class="text-base font-semibold">Change your Password..</p>

    <div class="flex flex-col my-2">
      <label for="current">Current Password</label>
      <base-input type="password" placeholder="Enter Your Password" v-model="previousPassword">
        <template v-slot:icon>
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
              stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </template>
      </base-input>
    </div>
    <hr>
    <div class="my-2">
      <label for="new">New Password</label>
      <base-input type="password" placeholder="Enter Your Password" v-model="newPassword">
        <template v-slot:icon>
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
              stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </template>
      </base-input>
      <!-- <input type="text" v-model="password_confirmation" class="input"  id="new" placeholder="--Enter--"> -->
    </div>
    <div class="flex flex-col">
      <div class="flex gap-2 py-2">
        <!-- <span class="bg-primary-yellow h-1 w-full rounded"></span>
          <span class="bg-primary-yellow h-1 w-full rounded"></span>
          <span class="bg-primary-yellow h-1 w-full rounded"></span>
          <span class="bg-primary-yellow h-1 w-full rounded"></span>
          <span class="bg-lightGrey h-1 w-full rounded"></span>s -->
      </div>
      <p class="text-sm text-lightGrey">ALL PASSWORDS MUST SATISFY THESE REQUIREMENTS. PASSWORD MUST HAVE:</p>
      <div class="text-sm">
        <p class="flex items-center py-1" :class="{ 'text-red': !hasUpperCase, 'text-green': hasUpperCase, }">
          <span v-if="hasUpperCase" class="pr-1">
            <checkmark />
          </span>
          <span v-else class="pr-1"> <img src="@/assets/images/cancel.png" /> </span>
          Must have at least 1 upper case character
        </p>
        <p class="flex items-center py-1" :class="{ 'text-red': !hasLowercase, 'text-green': hasLowercase, }">
          <span v-if="hasLowercase" class="pr-1">
            <checkmark />
          </span>
          <span v-else class="pr-1"> <img src="@/assets/images/cancel.png" /> </span>
          Must have at least 1 lower case character
        </p>
        <p class="flex items-center py-1" :class="{ 'text-red': !hasNumber, 'text-green': hasNumber, }">
          <span v-if="hasNumber" class="pr-1">
            <checkmark />
          </span>
          <span v-else class="pr-1"> <img src="@/assets/images/cancel.png" /> </span>
          Must have at least 1 number
        </p>
        <p class="flex items-center py-1" :class="{ 'text-red': !hasSpecialChars, 'text-green': hasSpecialChars, }">
          <span v-if="hasSpecialChars" class="pr-1">
            <checkmark />
          </span>
          <span v-else class="pr-1"> <img src="@/assets/images/cancel.png" /> </span>
          Must have at least 1 special character or symbol
        </p>
        <p class="flex items-center py-1" :class="{ 'text-red': !hasEightChars, 'text-green': hasEightChars, }">
          <span v-if="hasEightChars" class="pr-1">
            <checkmark />
          </span>
          <span v-else class="pr-1"> <img src="@/assets/images/cancel.png" /> </span>
          Must be at least 8 characters
        </p>
      </div>
    </div>
    <div class="my-2">
      <label class="label font-semibold">Confirm Password</label>
      <base-input type="password" placeholder="Confirm Your Password" v-model="confirmPassword"
        errorText="Passwords do not match!" :validation="newPassword == confirmPassword">
        <template v-slot:icon>
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
              stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </template>
      </base-input>
    </div>


    <div class="flex items-center justify-between my-4">
      <base-button text="Save" width="w-48" p="px-12 py-2" @click="resetPassword" :disabled="!isValidPassword"
        :loading="resettingPassword" />
      <div class="cursor-pointer ml-4" @click="closeModal">
        <p class="font-semibold">Cancel</p>
      </div>
    </div>
  </modal>
</template>

<script>
import Checkmark from '@/components/Auth/Home/Checkmark'

export default {
  components: {
    Checkmark
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // newPassword: '',
      // password_confirmation: '',
      // isValidToken: false,
      // verifyingToken: false,

      resettingPassword: false,
      // userId: "5b1c2425-9251-43b5-9526-754b22d9eeda",
      previousPassword: "",
      newPassword: "",
      confirmPassword: ""
    }
  },
  computed: {
    hasEightChars() {
      return this.newPassword.length >= 8 ? true : false
    },
    hasUpperCase() {
      return /[A-Z]/.test(this.newPassword)
    },
    hasLowercase() {
      return /[a-z]/.test(this.newPassword)
    },
    hasNumber() {
      return /\d/.test(this.newPassword)
    },
    hasSpecialChars() {
      return /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.newPassword)
    },
    isValidPassword() {
      return (
        this.hasEightChars &&
        this.hasUpperCase &&
        this.hasLowercase &&
        this.hasNumber &&
        this.hasSpecialChars &&
        this.newPassword == this.confirmPassword
      )
    },
    userId() {
      return this.$store.state.authentication.userId;
    }
  },
  mounted() {
    // this.checkTokenValidity()
  },
  methods: {
    createTokenString() {
      // Grabs the query params from the url
      let urlParams = window.location.search
      // Removes the ? and adds the params as the second item to a new array
      let queryArr = urlParams.split('?')
      console.log(urlParams, "uren")
      // Seprates each param into its own item in a new array
      let queryString = queryArr[1].split('&')
      // splits the first item in the array which holds the token into the value and the paam name
      let tokenArr = queryString[0].split('=')
      // grabs the token value which would be at the second position of the toknArr
      let token = tokenArr[1]
      return token
    },
    async checkTokenValidity() {
      this.verifyingToken = true
      let token = this.createTokenString()
      let email = this.$route.query.email
      let id = this.$route.query.id
      // console.log(token)
      try {
        let response = await this.$_checkResetPasswordTokenValidity(
          token,
          email,
          id
        )
        this.log(response)
        this.verifyingToken = false
        this.isValidToken = true
      } catch (error) {
        this.handleError(error)
        this.isValidToken = false
      }
      this.verifyingToken = false
    },
    async resetPassword() {
      this.resettingPassword = true
      let requestObject = {
        userId: this.userId,
        previousPassword: this.previousPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword
      }
      try {
        let response = await this.$_resetPassword(requestObject)
        console.log(response)
        this.handleSuccessfulResponse()
      } catch (error) {
        this.resettingPassword = false
        console.log(error.response)
        this.handleError(error)
      }
    },
    handleSuccessfulResponse() {
      // this.passwordIsReset = true
      this.resettingPassword = false
      this.generateToast(
        'Your newPassword has been successfully reset! You can now login.',
        'success'
      )
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal")
    }
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

input {
  background: #F9FAFC;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
